import React from "react";
import styles from './ModalConfirmTransfer.module.css'

export default function ModalConfirmTransfer({close}) {
    return(
        <div className={styles.overlay}>
            <div className={styles.modalController}>
                <div className={styles.contentModal}>
                    <div style={{marginBottom: '10px'}}>สำเร็จ</div>
                    <div>กรุณารอทางแอดมินห้องปฏิบัติการ</div>
                    <div>ดำเนินการตอบรับคำขอย้ายสังกัดของท่าน</div>
                </div>
                <div className={styles.closeButton}>
                    <div className={styles.textButton} onClick={() => { close() }}>ปิด</div>
                </div>
            </div>
        </div>
    )
}